import { useEffect, useState } from "react";
import {
  EntryType,
  getTournamentUserHistory,
  ParticipantHistoryDto,
  PaymentMethod,
} from "../../../../../../api/tournament-participant";
import PopupPagination from "../../../../../../component/Pagination/popupPagination";
import { formatDate } from "../../../../../../utils/date";
import {
  MobileMemberHistoryWrapper,
  MobileMemberHistoryHeader,
  MobileMemberHistoryInfoHeader,
  MobileMemberHistoryListItem,
  MobileMemberHistoryListWrapper,
} from "./style";
import { Title } from "../../../../../../styles/page";
import { useControllerContext } from "../../../../hooks/controller-context";
import { Const } from "../../../../../../common/const/const";
import { useParticipantContext } from "../../../sit-in/hooks/participant-context";

export const MobileControllerSitInMemberHistory = () => {
  const { setIsHistoryPopup, handleReEntryDelete, selectedMember } =
    useParticipantContext();
  const { data } = useControllerContext();
  const [allList, setAllList] = useState<ParticipantHistoryDto[]>([]);
  const [list, setList] = useState<ParticipantHistoryDto[]>([]);
  const [totalLength, setTotalLength] = useState<number>(0);
  const [totalPay, setTotalPay] = useState<number>(0);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const getData = async () => {
    if (!data || !selectedMember) return;
    try {
      const res = await getTournamentUserHistory(
        selectedMember.memberId,
        data.id,
      );
      setTotalLength(res.length);
      const sum = res.reduce((sum, curr) => (sum += handlePayAmount(curr)), 0);
      setTotalPay(sum);
      setAllList(res);
    } catch (e: any) {
      console.log(e);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  const onPageChange = async (nextPage: number) => {
    setCurrentPage(nextPage);
  };

  useEffect(() => {
    setTotalPage(Math.max(1, Math.ceil(allList.length / 5)));
    setList(allList.slice((currentPage - 1) * 5, currentPage * 5));
  }, [currentPage, allList]);

  // 결제 금액 총 합
  const handlePayAmount = (item: ParticipantHistoryDto) => {
    if (
      item.participantPaymentMethod.some(
        (pay) => pay.paymentMethod === PaymentMethod.SEED,
      )
    ) {
      let result = 0;
      item.participantPaymentMethod.forEach((pay) => {
        if (pay.paymentMethod !== PaymentMethod.SEED) {
          result += pay.amount;
        } else {
          result += pay.amount * Const.SEED_RATE;
        }
      });
      return result;
    }
    return item.paymentAmount;
  };

  const getEntryTypeText = (item: ParticipantHistoryDto) => {
    switch (item.entryType) {
      case EntryType.BUY_IN:
        return "엔트리";
      case EntryType.RE_BUY:
        return "리엔트리";
      case EntryType.ADD_ON:
        return `애드온(${item.isCount ? "Y" : "N"})`;
    }
  };

  const handleDeleteClick = async (id: number) => {
    try {
      await handleReEntryDelete(id);
    } catch (e) {
    } finally {
      getData();
    }
  };

  return (
    <MobileMemberHistoryWrapper>
      <MobileMemberHistoryHeader>
        <Title size={15}>{selectedMember?.nickname}님 이용 내역 목록</Title>
        <div className="back" onClick={() => setIsHistoryPopup(false)}>
          <img src="/image-web/solution/close.svg" alt="close" />
        </div>
      </MobileMemberHistoryHeader>
      <MobileMemberHistoryInfoHeader>
        <div>총 참여 횟수: {totalLength}</div>
        <div>총 결제 금액 : {totalPay.toLocaleString()}원</div>
      </MobileMemberHistoryInfoHeader>
      <MobileMemberHistoryListWrapper>
        {list.map((item, index) => (
          <MobileMemberHistoryListItem key={index}>
            <div className="a">
              {formatDate(item.createdAt.toString())} (LV {item.level})
            </div>
            <div className="b">{handlePayAmount(item).toLocaleString()}원</div>
            <div className="item">{getEntryTypeText(item)}</div>
            <div className="item" onClick={() => handleDeleteClick(item.id)}>
              {item.entryType !== "BUY_IN" && <span>삭제</span>}
            </div>
          </MobileMemberHistoryListItem>
        ))}
      </MobileMemberHistoryListWrapper>
      {totalPage > 1 && (
        <PopupPagination
          currentPage={currentPage}
          totalPages={totalPage}
          onPageChange={onPageChange}
        />
      )}
    </MobileMemberHistoryWrapper>
  );
};
